import { render, staticRenderFns } from "./OperaShopApproveWindow.vue?vue&type=template&id=1d89a6c3&scoped=true&"
import script from "./OperaShopApproveWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopApproveWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopApproveWindow.vue?vue&type=style&index=0&id=1d89a6c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89a6c3",
  null
  
)

export default component.exports